import React from 'react';

import { useTranslation } from 'react-i18next';

import { useTimeRemaining } from '@hooks/use-time-remaining';

import * as Styled from './timer-block.styled';

type OwnProps = {
	endDate: string;
	isPendingRace: boolean;
};

export const TimerBlock = ({ endDate, isPendingRace }: OwnProps) => {
	const { t } = useTranslation('coin_race_details');

	const timeLeft = useTimeRemaining(endDate);

	if (timeLeft.isFinished || isPendingRace) {
		return null;
	}
	return (
			<Styled.TimerBlock>
				<Styled.TimerLabel>{t('time_left_label')}</Styled.TimerLabel>
				<Styled.TimerValues>
					{timeLeft.days > 0 && (
						<>
							<Styled.TimerUnit>
								<Styled.TimerValue>{timeLeft.days}</Styled.TimerValue>
								<Styled.TimerUnitLabel>
									{t('days_plur', { count: timeLeft.days, prefix: '', suffix: '' })}
								</Styled.TimerUnitLabel>
							</Styled.TimerUnit>
							<Styled.TimerSeparator>:</Styled.TimerSeparator>
						</>
					)}
					<Styled.TimerUnit>
						<Styled.TimerValue>{timeLeft.hours}</Styled.TimerValue>
						<Styled.TimerUnitLabel>
							{t('hours_plur', { count: timeLeft.hours, prefix: '', suffix: '' })}
						</Styled.TimerUnitLabel>
					</Styled.TimerUnit>
					<Styled.TimerSeparator>:</Styled.TimerSeparator>
					<Styled.TimerUnit>
						<Styled.TimerValue>{timeLeft.minutes}</Styled.TimerValue>
						<Styled.TimerUnitLabel>
							{t('minutes_plur', { count: timeLeft.minutes, prefix: '', suffix: '' })}
						</Styled.TimerUnitLabel>
					</Styled.TimerUnit>
				</Styled.TimerValues>
			</Styled.TimerBlock>
	);
};
